import { ChevronLeft, X } from 'lucide-react'

export function MiniHeader({ onBack, onClose }: { onBack?: () => void; onClose?: () => void }) {
  return (
    <div className="flex items-center justify-between text-gray-600">
      {onBack ? (
        <button onClick={onBack} className="flex items-center">
          <ChevronLeft className="h-5 w-5" />
          <div>Retour</div>
        </button>
      ) : (
        <div className="w-20" />
      )}
      <button onClick={onClose}>
        <X className="h-6 w-6" />
      </button>
    </div>
  )
}
